import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { teamMembers } from '../data/mockData';
import { Mail } from 'lucide-react';

const Management = () => {
  const { language, t } = useLanguage();

  return (
    <div className="min-h-screen bg-[#0a0a0a] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-light text-white mb-6 tracking-wide">
            {t.management.title}
          </h1>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto leading-relaxed">
            {t.management.subtitle}
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className="group bg-gradient-to-br from-gray-900/50 to-gray-900/30 border border-gray-800 rounded-lg overflow-hidden hover:border-[#d4c5a9]/50 transition-all duration-300 hover:scale-[1.02]"
            >
              {/* Image - Clickable with mailto */}
              <a 
                href={`mailto:${member.mailto}`}
                className="block aspect-square overflow-hidden bg-gray-800 cursor-pointer hover:opacity-90 transition-opacity"
                title="Cliquez pour envoyer une mission secrète !"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </a>

              {/* Content */}
              <div className="p-6">
                <h2 className="text-2xl font-medium text-white mb-2 group-hover:text-[#d4c5a9] transition-colors">
                  {member.name}
                </h2>
                <p className="text-[#d4c5a9] font-medium mb-1">
                  {member.position[language]}
                </p>
                <p className="text-sm text-gray-500 mb-4">
                  {member.nationality}
                </p>
                <p className="text-sm text-gray-400 leading-relaxed">
                  {member.bio[language]}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Team Stats */}
        <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
          <div>
            <div className="text-5xl font-light text-white mb-2">30+</div>
            <p className="text-gray-400 tracking-wide">{t.team.stats.languages}</p>
          </div>
          <div>
            <div className="text-5xl font-light text-white mb-2">2800+</div>
            <p className="text-gray-400 tracking-wide">{t.team.stats.cases}</p>
          </div>
          <div>
            <div className="text-5xl font-light text-white mb-2">5000+</div>
            <p className="text-gray-400 tracking-wide">{t.team.stats.sources}</p>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center">
          <a
            href="mailto:contact@global-intelligence.fr"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#d4c5a9] hover:bg-[#e5d7bb] text-black font-medium rounded transition-all duration-300 hover:scale-105"
          >
            <Mail className="w-5 h-5" />
            {t.about.cta}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Management;